import React, { useEffect } from 'react';
import useGameStore from '../engine/store';

export default function AchievementToast() {
  const { showAchievementToast, dismissAchievement } = useGameStore();

  useEffect(() => {
    if (showAchievementToast) {
      const timer = setTimeout(dismissAchievement, 4000);
      return () => clearTimeout(timer);
    }
  }, [showAchievementToast, dismissAchievement]);

  if (!showAchievementToast) return null;

  const a = showAchievementToast;

  return (
    <div className="fixed top-4 right-4 z-50 animate-slide-up" onClick={dismissAchievement}>
      <div className="glass-panel p-4 border border-neon-yellow/30 shadow-lg shadow-neon-yellow/10 cursor-pointer hover:scale-105 transition-transform"
        style={{ minWidth: 280 }}>
        <div className="flex items-center gap-3">
          <div className="text-3xl">{a.emoji}</div>
          <div>
            <div className="text-xs text-neon-yellow uppercase tracking-wider font-bold">🏆 Achievement Unlocked</div>
            <div className="text-sm font-bold text-white mt-0.5">{a.title}</div>
            <div className="text-xs text-gray-400">{a.desc}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
